var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-carousel"},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.carousel.heybox_info.avatar}})]),_c('div',{staticClass:"desc",style:(_vm.fontColor),domProps:{"innerHTML":_vm._s(_vm.carousel.title)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }